import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { toast } from 'react-toastify'; 

let initialState = {
    user : "",
    token : "",
    loading: false,

}

export const loginUser = createAsyncThunk('user', async(body) => {
    let res = await  fetch ("http://202.65.140.22:8081/login",{
        method : "POST",
        headers : {
            "Content-Type" : "application/json",
            "Athorization" : localStorage.getItem("token"),
        },
        body : JSON.stringify(body)
    })
    return await res.json();
})

const authSlice = createSlice({
    name:"user",
    initialState,
    reducers: {
        addToken:(state)=>{
            state.token = localStorage.getItem("token");
        },
        addUser:(state)=>{
            state.user = localStorage.getItem("user");
        }

    },
    exctrareducers: {
        [loginUser.pending]: (state,action) => {
            state.loading = true;
          },
          [loginUser.fulfilled]: (state, { payload:{user, token} }) => {
            
            state.loading = false;

            state.token = token;
            state.user = user;
            localStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("token", JSON.stringify(token));
          
      
            // toast.success(`Welcome Back ${user.name}`);
          },
          [loginUser.rejected]: (state,action) => {
            state.loading = false;
            //toast.error(payload);
          },
    }
})

export const {addToken, addUser} = authSlice.actions;

export default authSlice.reducer;